module.exports = __webpack_public_path__ + "static/media/icon-subscription.04d37ebd.svg";